import React, { createContext, useContext, useState, useEffect } from "react";

const CompanyContext = createContext();
const STORAGE_KEY = 'selectedCompany';

export const useCompany = () => useContext(CompanyContext);

export const CompanyProvider = ({ children }) => {
  // Initialize state from localStorage or null
  const [selectedCompany, setSelectedCompany] = useState(() => {
    const storedCompany = localStorage.getItem(STORAGE_KEY);
    return storedCompany ? JSON.parse(storedCompany) : null;
  });

  // Update localStorage whenever selectedCompany changes
  useEffect(() => {
    if (selectedCompany) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(selectedCompany));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }, [selectedCompany]);

  return (
    <CompanyContext.Provider value={{ selectedCompany, setSelectedCompany }}>
      {children}
    </CompanyContext.Provider>
  );
};